export const formatNumberWithCommas = (number: number): string => {
  return number.toLocaleString("en-US");
};

export const formatCommasNumber = (value: number) => {
  return new Intl.NumberFormat("ko-KR").format(value);
};

export const formatNumber = (value: number, isMinus: boolean = false) => {
  if (value === 0) return "0";
  const formattedNumber = Math.abs(value).toLocaleString("ko-KR");
  return isMinus ? `-${formattedNumber}` : formattedNumber;
};
